<template>
  <div>
    <h2 class="text-text-neutral-primary mb-3 text-lg font-semibold leading-6">
      {{ t('search.filters.transfers') }}
    </h2>
    <div class="no-scrollbar space-x-2 overflow-auto whitespace-nowrap">
      <button
        v-for="i of transfersNumber"
        :key="i"
        ref="transferAmountButtonRef"
        type="button"
        class="inline-block rounded-xl border px-3.5 py-1.5 text-sm focus:outline-none disabled:opacity-40"
        :class="
          maxTransfers === i
            ? 'bg-background-positive-primary text-static-white border-background-positive-primary'
            : 'text-text-neutral-tertiary border-situational-lightgrey'
        "
        :disabled="!availableNumberOfTransfers.has(i)"
        @click="onClick(i)"
      >
        {{
          i === 0
            ? t('search.filters.withoutTransfers')
            : t('search.filters.before', { value: i })
        }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { ref } from 'vue';

  defineProps<{
    maxTransfers?: number;
    availableNumberOfTransfers: Set<number>;
  }>();

  const emit = defineEmits<{
    onTransferAmountChange: [transferAmount: number];
  }>();

  const { t } = useI18n();
  const transfersNumber = [0, 1, 2, 3];

  const transferAmountButtonRef = ref<HTMLButtonElement[] | null>(null);

  function onClick(index: number) {
    emit('onTransferAmountChange', index);

    if (transferAmountButtonRef.value) {
      transferAmountButtonRef.value[index].scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }
  }
</script>
